import { useEffect, useMemo } from 'react';

const useAppRedirect = (fromPath: string, toPath: string) => {
  const isFinalPath = useMemo(() => !window.location.pathname.includes(fromPath), [fromPath]);

  useEffect(() => {
    if (!isFinalPath) {
      const url = window.location.href.split('#')[1];
      window.location.replace(`${toPath}/#${url}`);
    }
  }, [isFinalPath, toPath]);

  return isFinalPath;
};

export default useAppRedirect;
